import React from "react";
const Image_1 = "../assets/img/Loading.png";
const BrokenImage = '../assets/img/not_found.png'

export default function
    ViewURL({ setshowImagePopup, ImagePopUpData, Heading }) {

    const imageOnLoad = (event) => {
        console.log(event)
        console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
        if (event.currentTarget.className !== "error") {
            event.currentTarget.className = "success";
        }
    };
    const imageOnError = (event) => {
        event.currentTarget.src = BrokenImage;
        event.currentTarget.className = "error";
    };

    return (
        <>
            <div className=" modal show fade" style={{ display: "block", backgroundColor: "#00000055", overflow: 'auto' }} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered mt-5" role="document">
                    <div className="modal-content" id='nested'>
                        <div className="modal-header popheding" id="popupheading">
                            <div className=" ml-4">
                                <span style={{ fontSize: '19px', fontWeight: 'bold' }}>{Heading ? Heading : 'Area Name Photo'}</span>
                            </div>

                            <button type="button" className="btn-close mr-3 mt-1" data-dismiss="modal" aria-label="Close" data-backdrop='static'
                                style={{ color: 'white' }}
                                onClick={() => {
                                    setshowImagePopup(false)
                                }}>
                            </button>
                        </div>
                        <div className="col-12 modal-body" >
                            <div className="col-12 modal-header justify-content-center" >

                                {
                                    ImagePopUpData ?
                                        <img className="col-12"
                                            style={{ width: "400px", height: "400px" }}
                                            src={ImagePopUpData == null ? "ImageNotFound" : ImagePopUpData}
                                            onLoad={imageOnLoad} onError={imageOnError} />
                                        : <img src="../assets/img/not_found.png" />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


